import { render, staticRenderFns } from "./IndividualG.vue?vue&type=template&id=e0a9c86c"
import script from "./IndividualG.vue?vue&type=script&lang=js"
export * from "./IndividualG.vue?vue&type=script&lang=js"
import style0 from "./IndividualG.vue?vue&type=style&index=0&id=e0a9c86c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports